import AdminDashboardPage from '../../../components/admin/dashboard/AdminDashboardPage'

export default function Overview() {
  return <AdminDashboardPage />
}
